export type MessengerChatRate = 'good' | 'poor'

type MessengerChatIdleState = {
  type: 'idle'
}
type MessengerChatLoadingState = {
  type: 'loading'
  error?: unknown
}
type MessengerChatWaitingState = {
  type: 'waiting'
}
type MessengerChatOpenedState = {
  type: 'opened'
  agent: {
    name: string
    avatarUrl: string
  }
}
type MessengerChatEndedState = {
  type: 'ended'
  isNoAgents?: boolean
  isOffline?: boolean
  rate?: MessengerChatRate
  comment?: string
}

export type MessengerChatState =
  | MessengerChatIdleState
  | MessengerChatLoadingState
  | MessengerChatWaitingState
  | MessengerChatOpenedState
  | MessengerChatEndedState

export type MessengerNewMessageState = {
  firstNewMessageId: number | string // id of incoming message
  isViewed: boolean
}

export type MessengerMessageListState = {
  isAllMessagesLoaded: boolean
  isNextPageLoading: boolean
}

export const isChatIdleState = (state: MessengerChatState): state is MessengerChatIdleState => state.type === 'idle'

export const isChatLoadingState = (state: MessengerChatState): state is MessengerChatLoadingState =>
  state.type === 'loading'

export const isChatWaitingState = (state: MessengerChatState): state is MessengerChatWaitingState =>
  state.type === 'waiting'

export const isChatOpenedState = (state: MessengerChatState): state is MessengerChatOpenedState =>
  state.type === 'opened'

export const isChatEndedState = (state: MessengerChatState): state is MessengerChatEndedState => state.type === 'ended'

export const isChatNoAgentsState = (
  state: MessengerChatState,
): state is MessengerChatEndedState & { isNoAgents: true } => isChatEndedState(state) && !!state.isNoAgents

export const isChatOfflineState = (
  state: MessengerChatState,
): state is MessengerChatEndedState & { isNoAgents: true; isOffline: true } =>
  isChatEndedState(state) && !!state.isOffline

export const isChatRatedState = (
  state: MessengerChatState,
): state is MessengerChatEndedState & { rate: MessengerChatRate } => isChatEndedState(state) && state.rate !== undefined

export const isChatCommentedState = (
  state: MessengerChatState,
): state is MessengerChatEndedState & { comment: string } => isChatRatedState(state) && state.comment !== undefined
